import {
  baseVendorApiSettingsDefaults,
  defaultRateLimitationSettings,
} from './base';
import type { AwsApiSettingsDefaults } from './types';

export const awsDefaults: AwsApiSettingsDefaults = {
  ...baseVendorApiSettingsDefaults,
  ...defaultRateLimitationSettings,
  apiVersion: '2016-11-15',
  assumedRoleExpirationDefaultSec: 900,
  reassumeRoleSafetyFactorPct: 80,
  requestLimitExceededMaxAttempts: 3,
  maxCapacity: 50,
  refillRate: 10,
  regions: [],
};
